
export const AuthReligio = ({ auth, handleChange, error }) => {
  return (<>
  <div className="row">
    <div className="col col-12 ">
      <h4>
        Declaració sobre l'opció per la formació religiosa o els ensenyaments alternatius
      </h4>
      <p>
        La Constitució proclama el dret que us assisteix com a pares per tal que a l'escola els vostres fills rebin
        la formació religiosa i moral que estigui d'acord amb les vostres conviccions (art. 27.3).<br/>
        Per tal de facilitar-vos l'exercici d'aquest dret fonamental, i d'acord amb la normativa vigent, caldrà que
        manifesteu a la direcció del centre si desitgeu que el vostre fill o filla, rebi formació religiosa a l'institut
        durant l'etapa d'Educació Secundària Obligatòria.<br/>

        Respecte a aquesta qüestió, us recordem el següent:
      </p>
        <ul>
          <li>
            El centre té l'obligació de garantir l'oferta de formació religiosa perquè tots els alumnes els
            pares del qual hi manifesteu interès puguin rebre aquesta formació.
          </li>
          <li>
            L'opció per la Religió consisteix en 3 crèdits per cicle. Els alumnes que no rebin formació
            religiosa en l'educació secundària realitzaran uns ensenyaments alternatius que
            consisteixen en 3 crèdits variables per cicle.
          </li>
        </ul>

        <label>
          <input type="radio" id="authReligio" name="authReligio" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange("1") }} required /> DESITGEM que el/la nostre/a fill/a rebi FORMACIÓ RELIGIOSA: CATÒLICA
          </label>

        <br />
        <br />

        <label> 
         <input type="radio" id="authReligio" name="authReligio" value={auth} checked={auth === "2" ? true : false} onChange={(t) => { handleChange("2") }} required /> DESITGEM que el/la nostre/a fill/a rebi els ENSENYAMENTS ALTERNATIUS
        </label>

        <span id="auhtReligio_ERROR" className="a-Form-error">{error}</span>

    </div>
  </div>

    <br />
  </>)
}
